import { createInstance } from 'src/api';
import type { schemas } from 'src/features/quant/schema';
import { appConfig } from 'src/lib/config';
import { container } from 'src/StaticContainer';
import type { z } from 'zod';

const quantApi = createInstance({ baseURL: appConfig.quantApi });

const log = container.get('Logger').getSubLogger({ name: 'NewsSummariesApi' });

type SummarizeNewsBySymbolResponse = z.infer<typeof schemas.SummarizeNewsBySymbolResponse>;

export async function getNewsSummaryForSymbol(symbol: string, start: string, end: string): Promise<string> {
    try {
        const res = await quantApi.get<SummarizeNewsBySymbolResponse>(
            `/v1/news-summaries/by-symbol/${encodeURIComponent(symbol)}`,
            { params: { start, end } },
        );
        return res.data.response ?? '';
    } catch (e) {
        log.error('Failed to fetch news summary', { error: e, symbol });
        throw e;
    }
}
